import { Box, Container, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100vh',
  },
  boxStatistics: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2.5%',
    margin: theme.spacing(0, 0, 8, 0),
  },
  boxListLessons: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2, 0),
  },
}));

export default function SkeletonStatistics() {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Box className={classes.boxStatistics}>
        <Skeleton variant="rect" width={516} height={132} />
      </Box>
      <Box className={classes.boxListLessons}>
        <Skeleton variant="rect" width="95%" height={70} />
      </Box>
      <Box className={classes.boxListLessons}>
        <Skeleton variant="rect" width="95%" height={70} />
      </Box>
      <Box className={classes.boxListLessons}>
        <Skeleton variant="rect" width="95%" height={70} />
      </Box>
    </Container>
  );
}
